module.exports = __webpack_public_path__ + "img/vmcHiring_03062025.7299e2b4.jpg";